/**
 * Created by Administrador on 28/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('operationEconomicActivityService',operationEconomicActivityService);

    operationEconomicActivityService.$inject = ['$http', 'CONFIG','messageService','$state'];

    function operationEconomicActivityService($http, CONFIG, messageService,$state){

        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FINANCE + '/' + CONFIG.API + '/operationEconomicActivities';

        var service = {
            getOperationsNotInEconomicActivity: getOperationsNotInEconomicActivity,
            getOperationsByEconomicActivity: getOperationsByEconomicActivity,
            saveOperationEconomicActivity: saveOperationEconomicActivity,
            deleteOperationEconomicActivity: deleteOperationEconomicActivity
        };

        return service;

        function getOperationsNotInEconomicActivity(id){
            return $http.get(urlBase+"/"+id+"/notInEconomicActivity")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.operationEconomicActivities : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function getOperationsByEconomicActivity(id){
            return $http.get(urlBase+"/"+id+"/byEconomicActivity")
                .then(function(response){
                    return (response.data._embedded) ? response.data._embedded.operationEconomicActivities : [];
                }, function(){
                    messageService.findAllError('');
                });
        }

        function saveOperationEconomicActivity(operationEconomicActivity){
            return $http.post(urlBase, operationEconomicActivity)
                .then(function(){
                    messageService.register('economicActivitySettings');
                    $state.go('economicActivitySettings', null, { reload: true });
                }, function(){
                    messageService.registerError('');
                    $state.go('economicActivitySettings', null, { reload: true });
                });
        }

        function deleteOperationEconomicActivity(id){
            return $http.delete(urlBase + "/" + id)
                .then(function(){
                    messageService.registerDelete('economicActivitySettings');
                    $state.go('economicActivitySettings', null, { reload: true });
                }, function(){
                    messageService.registerDeleteError('');
                    $state.go('economicActivitySettings', null, { reload: true });
                })
        }
    }
})();
